<template>
  <div class="user-group">
    <div class="user-group__user"
      v-for="(item, index) in actualPage(users)"
      :key="index"
      @click="selectUser(item)"
      :class="[isSelected(item) ? 'user-group__user--selected' : '']">
      
      <livechat-user-card
        class="user-group__user-card"
        :name="getUserNameForCard(item.userData)"
        :img="item.userData.profile_pic"
        :newMsg="item.liveData.new"
        :tags="item.liveData.tags"
        >

        <template v-slot:addInfo>
          <div class="lc-users__tags-cont user-group__tags-cont">
            <div class="lc-users__tag user-group__tag"
            v-for="(tag, index2) in item.liveData.tags"
            :key="index2">
              <dynamic-text
                class="lc-users__tag-text user-group__tag-text"
                :minWidth="40"
                :value="tag.name"
                noAnim
              />
              <fai class="lc-users__tag-del"
                icon="times"
                @click.stop="deleteTagConnection(item, index2)"
              ></fai>
            </div>
            <div class="user-group__tag-add">
              <fai class="user-group__tag-add-icon"
                icon="plus"
                @click.stop="enableSelect($event, item)"
              ></fai>
            </div>
          </div>
        </template>

      </livechat-user-card>
    </div>
    <div v-show="showSelect">
      <div class="user-group__tag-blocker" @click="showSelect = false">
      </div>
      <livechat-tag-sel
        class="user-group__tag-sel"
        ref="tagSel"
        :tags="tagsToShow"
        @selected="addNewTagConnection($event)"
        @close="showSelect = false"
      ></livechat-tag-sel>
    </div>
    <slot name="after"></slot>
  </div>
</template>

<script>
import axios from '@/axios'

export default {
  data () {
    return {
      showSelect: false,
      tagsToShow: [],
      selectingForUser: null
    }
  },

  watch: {
    users () {
      this.userGroup.count = this.users.length
    }
  },

  props: {
    toggled: {
      type: Boolean,
      default: true
    },
    users: {
      type: Array,
      default: []
    },
    selectedUser: {
      type: Object,
      default: null
    },
    tags: Array,
    userGroup: null,
    socket: null
  },

  methods: {
    actualPage (users) {
      if(!this.userGroup) return []
      return users.slice(this.userGroup.pagingIter*this.userGroup.pageLimit, this.userGroup.pagingIter*this.userGroup.pageLimit+this.userGroup.pageLimit)
    },

    getLastMsg (msgs) {
      if(!msgs) return 'not loaded'
      for(let i = msgs.length-1; i>=0; i--) {
        if(msgs[i].user) {
          if(msgs[i].attachment) return '(attachment)'
          else return msgs[i].message
        }
      }
    },

    getUserNameForCard (userData) {
      return userData.first_name + ' ' + userData.last_name
    },

    selectUser(user) {
      this.$emit('selected', user)
    },

    isSelected(user) {
      if(user == this.selectedUser) return true
      return false
    },

    enableSelect (e, user) {
      this.tagsToShow = this.tags.filter((item) => {
        for(let i = 0; i<user.liveData.tags.length; i++) {
          if(item.id === user.liveData.tags[i].id) return false
        }
        return true
      })

      const elemSel = this.$refs.tagSel.$el
      if(this.showSelect) {
        elemSel.style.top = e.clientY - elemSel.clientHeight + 'px'
        elemSel.style.left = e.clientX - elemSel.clientWidth + 'px'
      } else {
        setTimeout(() => {
          elemSel.style.top = e.clientY - elemSel.clientHeight + 'px'
          elemSel.style.left = e.clientX - elemSel.clientWidth + 'px'
        }, 0)
      }
      this.showSelect = true
      this.selectingForUser = user
    },

    async addNewTagConnection (tag) {
      try {
        this.showSelect = false
        const res = await axios.post('/api/livechat/tags/connections',  {
          connections: [{
            users_id: this.selectingForUser.userData.id,
            livechat_tags_id: tag.id
          }]
        })
        tag.users.push(this.selectingForUser)
        this.selectingForUser.liveData.tags.push(tag)

        this.selectingForUser = null
      } catch (e) {
        this.selectingForUser = null
        console.error(e)
      }
    },

    async deleteTagConnection (user, tagIndex) {
      try {
        const actTag = user.liveData.tags[tagIndex]

        await axios.delete('/api/livechat/tags/connections', {
          data: {
            connection: {
              users_id: user.userData.id,
              livechat_tags_id: actTag.id
            }
          }
        })

        user.liveData.tags.splice(tagIndex, 1)
      } catch (e) {
        console.error(e)
      }
    }
  }
}
</script>

<style lang="scss">
.user-group {
  &__user {
    margin-bottom: 8px;
    cursor: pointer;
    @include boxShadow(-2px, 2px, 10px, -10px, rgba(0, 0, 0, 0.75));

    & .lc-user-card__name {
      transition: color 0.2s;
    }

    & .lc-user-card__msg {
      transition: color 0.2s;
    }

    & .lc-user-card__content {
      transition: background-color 0.2s;
    }

    &--selected {
      & .lc-user-card__name {
        color: white;
      }

      & .lc-user-card__msg {
        color: white;
      }

      & .lc-user-card__content {
        background-color: $primary;
      }

      & .user-group__tag-add-icon{
        color: $borderGrey;
      }
    }

    &:last-child {
      margin-bottom: 0px;
    }
  }

  &__tags-cont {
    justify-content: left;
    margin-top: 4px;
    align-items: center;
  }

  &__tag {
    //pointer-events: none;
  }

  &__tag-text {
    pointer-events: none;
  }

  &__tag-add {
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 1px 0 0 2px;
  }

  &__tag-blocker {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
  }

  &__tag-sel {
    position: fixed;
  }

  &__tag-add-icon {
    font-size: 0.9em;
    color: $inactiveGrey;
    cursor: pointer;
  }
}
</style>
